module.exports = __webpack_public_path__ + "img/mclogi-mobile1.3b8259c.png";